import { useState, useEffect } from 'react'
import { Modal, Box, Typography, Checkbox, Button, Grid } from '@material-ui/core'
import { IAccountingTask } from 'models/accounting.models'

interface WorkspaceTasksModalProps {
    workspaceName: string
    tasks: IAccountingTask[]
    open: boolean
    onClose: () => void
    onToggleTask?: (taskId: number, checked: boolean) => void
}

const WorkspaceTasksModal = ({
                                 workspaceName,
                                 tasks: initialTasks,
                                 open,
                                 onClose,
                                 onToggleTask,
                             }: WorkspaceTasksModalProps) => {
    const [tasks, setTasks] = useState<IAccountingTask[]>([])

    useEffect(() => {
        const tasksCopy = initialTasks.map(task => ({ ...task }))
        setTasks(tasksCopy)
    }, [initialTasks])

    const handleToggleTask = (index: number) => {
        const updated = tasks.map((task, idx) =>
            idx === index ? { ...task, checked: !task.checked } : task
        )
        setTasks(updated)

        if (onToggleTask) {
            onToggleTask(updated[index].idTask, updated[index].checked)
        }
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    backgroundColor: '#fff',
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
                    padding: 16,
                    maxHeight: '80vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" component="h2" gutterBottom>
                    Tareas de {workspaceName}
                </Typography>

                {tasks.length === 0 ? (
                    <Typography variant="body2" color="textSecondary">
                        No hay tareas asignadas
                    </Typography>
                ) : (
                    tasks.map((task, idx) => (
                        <Grid container alignItems="center" key={task.idTask} spacing={1}>
                            <Grid item>
                                <Checkbox
                                    checked={task.checked}
                                    onChange={() => handleToggleTask(idx)}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item>{task.task}</Grid>
                        </Grid>
                    ))
                )}

                <Box mt={2} textAlign="right">
                    <Button variant="contained" color="primary" onClick={onClose}>
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default WorkspaceTasksModal
